import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/Service/auth.service';
import { CompanyService } from 'src/app/Service/company-service.service';
import { EventService } from 'src/app/Service/event.service';
import { QuestionCompany, SharedConstants } from 'src/app/models/index';
import { EnumEnrollType, EnumServicesValidation, EnumUserRol } from 'src/app/models/shared/app-enums';
import { CatEnrollSection } from 'src/app/models/shared/cat-generic';
import { CatStatusGeneric } from 'src/app/models/shared/cat-status-generic';
import { Company, CompanyCreateRq, UserAdminCompanyRq, MailNotifs } from 'src/app/models/shared/company';
import { ValidationServices } from 'src/app/models/shared/validation-services';
import { ConfirmationDialog } from '../../dialogs/ConfirmationDialog';
import { Provider } from 'src/app/models/shared/Provider';

import { element } from 'protractor';


/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-create-company',
  templateUrl: './create-company.component.html'
})

export class CreateCompanyComponent implements OnInit {
  matcher = new MyErrorStateMatcher();
  fmCompanyUser: FormGroup; 
  fmTypePerson: FormGroup;
  protected fmAssistance: FormGroup;
  fmServices: FormGroup;
  fmSections: FormGroup;

  regexEmail: string;
  regexRFC: string;
  regexPassword: string;
  protected regexOnlyNumbers: string;
  showDivUrlINE: boolean = true;
  currentUser: any;
  catStatus: CatStatusGeneric[] = [];
  catDocuments: CatStatusGeneric[] = [];

  show: boolean = false;
  showConfirmPassword: boolean;
  showBioStar: boolean;

  sectionToEnroll: CatEnrollSection[] = [];
  sectionCat_movil_android: CatEnrollSection[] = [];
  sectionCat_movil_iOS: CatEnrollSection[] = [];
  sectionCat_web: CatEnrollSection[] = [];
  sectionCat_web_responsive: CatEnrollSection[] = [];
  servicesToCompany: ValidationServices[] = [];
  servicesCat: ValidationServices[] = [];
  protected questionSections: string[] = ['lblOnboarding', 'lblEvidence', 'lblNotifications'];
  protected questionsCat: QuestionCompany[] = [];

  protected providersCAECat: any[] = [];

  companyEntity: Company = {};
  userEntity: UserAdminCompanyRq = {
    roles: [], fingerprints: false, enabled: true
  };


  //Variables seccion control de asistencia y evidencia
  public activateAsistance: boolean = false;
  public isValidCaeProvider: boolean = false;


  protected listEmailToNotifs: MailNotifs[] = [
    {
      mail: '',
      isRegex: false,
    }
  ];
  private uniqueEmailToNotifs: MailNotifs[];
  protected isCehckbxIsBioStar: boolean = true;
  protected isCehckbxIsNotifsMail: boolean = true;
  protected isCbxFaceComparation: boolean = true;
  protected isCbxLiveness: boolean = true;

  @ViewChild('formNotifsMail') templateCehckbxIsNotifsMail: TemplateRef<any>;
  @ViewChild('formBio') templateCehckbxIsBioStar: TemplateRef<any>;
  @ViewChild('formFace') templateFaceComparation: TemplateRef<any>;
  @ViewChild('formLiveness') templateLiveness: TemplateRef<any>;

  _idServices = [];

  private numberOfDocuments: string = "0";

  //mdlAddAdmin;
  protected mdlAddTypePersonLightIdentity;
  protected mdlAddAsistenciaEvidencia;
  mdlAddServices;
  mdlAddSection;
  protected mdlAddProviders;

  catMsg = [
    { keyLg: "warningAddService", textValue: "Para continuar es necesario seleccionar por lo menos un servicio." },
    { keyLg: "errorIneURL", textValue: "Ha seleccionado algún servicio de verificación con el INE; es necesario agregar una URL válida." },
    { keyLg: "warningIneURL", textValue: "Es necesario agregar una URL válida." },
    { keyLg: "errorFormValidation", textValue: "Existen errores en los datos. Favor de verificar." },
    { keyLg: "warningPasswordDoNotMatch", textValue: "Las contraseñas no coinciden. Favor de verificar." },
    { keyLg: "errorGetCatData", textValue: "Ocurrió un error al obtener la información del catálogo." },
    { keyLg: "documentsRequired", textValue: "Por favor seleccione la cantidad de documentos." },
    { keyLg: "biometricRequired", textValue: "Es necesario seleccionar una biometría para cada canal de enrolamiento." },
    { keyLg: "warningAddProvider", textValue: "Para continuar es necesario seleccionar los proveedores correspondientes." },
  ];

  /** For managment providers */
  protected catProvidersSections = [
    { id: 1, name: "lblFingerprintCaptureSection" },
    { id: 2, name: "lblOfficialIdCaptureSectionOcr" },
    { id: 3, name: "lblLivenessCheckSection" },
    { id: 4, name: "lblFaceCaptureSection" }
  ];
  protected listProviders: Provider[] = [];
  private providersSelect: Provider[] = [];
  private providersCaeSelect: Provider[] = [];
  private categoriasActivas: { [categoriaId: number]: number } = {};

  userId: string;

  /** Para llenar la compañía */
  private request: CompanyCreateRq;

  private numbersSections: number = 4;

  private selectFace: boolean = false;
  private selectFingerPrints: boolean = false;

  /** For controller the confirms dialogs */
  public confirmationDialog: ConfirmationDialog = new ConfirmationDialog();
  public isConfirmationDialog: boolean = false;

  /** For use translate */
  protected msg_confirmDialog: string = "";
  protected msgTwo_confirmDialog: string = "";

  protected isEnabled: boolean = false;

  constructor(
    private _router: Router,
    private sharedConstants: SharedConstants,
    private _fb: FormBuilder,
    private translate: TranslateService,
    private authService: AuthService,
    private _service: CompanyService,
    protected eventService: EventService,
    private _modalService: NgbModal) {

    this.authService.currentUser.subscribe(resp => {
      if (resp === null || resp.username === undefined)
        this.currentUser = null;
      else
        this.currentUser = resp;

      console.log(this.currentUser);
    });




    this.regexEmail = this.sharedConstants.regexPattern.email2Validator;
    this.regexPassword = this.sharedConstants.regexPattern.passwordValidator;
    this.regexRFC = this.sharedConstants.regexPattern.rfc2;
    this.regexOnlyNumbers = this.sharedConstants.regexPattern.numeric;

    // this.fmCompanyUser = this._fb.group({
    //   txtName: ['Comp' + Date.now(), [Validators.required, Validators.minLength(4)]],
    //   txtRFC: ['ABCD121212ABC', [Validators.required, Validators.minLength(12), Validators.maxLength(13), Validators.pattern(this.regexRFC)]],
    //   txtContactName: ['ABCD', [Validators.required, Validators.minLength(4)]],
    //   txtContactEmail: ['abcd' + Date.now() + '@bio.com', [Validators.required, Validators.minLength(10), Validators.maxLength(40), Validators.pattern(this.regexEmail)]],
    //   txtNameUser: ['user_' + Date.now(), [Validators.required, Validators.minLength(4)]],
    //   txtUserName: ['user_name' + Date.now(), [Validators.required, Validators.minLength(5)]],
    //   txtPhone: ['5512121212', [Validators.required, Validators.minLength(3)]],
    //   txtEmail: ['abcd' + Date.now() + '@bio.com', [Validators.required, Validators.minLength(10), Validators.maxLength(40), Validators.pattern(this.regexEmail)]],
    //   txtPassword: ['Facil123%', [Validators.minLength(8), Validators.maxLength(12), Validators.pattern(this.regexPassword)]],
    //   txtPassword2: ['Facil123%', [Validators.minLength(8), Validators.maxLength(12), Validators.pattern(this.regexPassword)]],
    //   ddlRol: [{ value: EnumUserRol.ADMIN.toString(), disabled: true }],
    // });

    this.fmCompanyUser = this._fb.group({
      txtName: ['', [Validators.required, Validators.minLength(4)]],
      txtRFC: ['', [Validators.required, Validators.minLength(12), Validators.maxLength(13), Validators.pattern(this.regexRFC)]],
      txtContactName: ['', [Validators.required, Validators.minLength(4)]],
      txtContactEmail: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(40), Validators.pattern(this.regexEmail)]],


      txtNameUser: ['', [Validators.required, Validators.minLength(4)]],
      txtUserName: ['', [Validators.required, Validators.minLength(5)]],
      txtPhone: ['', [Validators.required, Validators.minLength(3)]],
      txtEmail: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(40), Validators.pattern(this.regexEmail)]],
      txtPassword: ['', [Validators.minLength(8), Validators.maxLength(12), Validators.pattern(this.regexPassword)]],
      txtPassword2: ['', [Validators.minLength(8), Validators.maxLength(12), Validators.pattern(this.regexPassword)]],
      ddlRol: [{ value: EnumUserRol.ADMIN.toString(), disabled: true }],
    });
 

    this.fmTypePerson = this._fb.group({
      //IS OK FOR TYPE PERSONS --- IOMC
      //chckbxFPerson: [{value: true, disabled: true}, Validators.compose([Validators.required])], 
      //chckbxMPerson: [''], 
      mstLightIdentity: ['', Validators.compose([Validators.required])]
    });

    this.fmAssistance = this._fb.group({
      txtBioUser: new FormControl('', Validators.required),
      txtBioPassword: new FormControl('', Validators.required),
      txtBioServert: new FormControl('', Validators.required),
      txtBioPort: new FormControl('', [Validators.maxLength(5), Validators.pattern(this.regexOnlyNumbers), Validators.required]),
    });

    this.fmServices = this._fb.group({
      txtUrlINE: ['']
    });

    this.fmSections = this._fb.group({
      ddlDocuments: ['']
    });
  }

  ngOnInit(): void {
    this.getDataLanguage();
    this.userId = localStorage.getItem('userId');
    this.onLoadCat();
  }


  getDataLanguage() {
    this.catMsg.forEach(element => {
      this.translate.stream('companies.catMsg.' + element.keyLg).subscribe((res: string) => {
        element.textValue = res;
      });
    });

    this.translate.stream('common.confirmDialog.messageCancel').subscribe((res: string) => {
      this.msg_confirmDialog = res;
    });

    this.translate.stream('common.confirmDialog.messageTwoCancel').subscribe((res: string) => {
      this.msgTwo_confirmDialog = res;
    });
  }

  get fmDet() { return this.fmCompanyUser.controls; } 
  get fmTypePersonG() { return this.fmTypePerson.controls; }
  get fmAssistanceG() { return this.fmAssistance.controls; }
  get fmServicesG() { return this.fmServices.controls; }
  get fmSectionsG() { return this.fmSections.controls; }
  /**
   * For actions of by confirms dialogs, to do the correct process
   * @param $event For know the action to do
   */
  protected onClose(action: number): void {
    /** For active confirm dialog */
    if (action === 0) {
      this.confirmationDialog.keyConfirmDialog = "confirmExitCreateCompany";
      this.confirmationDialog.message = this.msg_confirmDialog;
      this.confirmationDialog.messageTwo = this.msgTwo_confirmDialog;
      this.isConfirmationDialog = true;
    }
    /** For confirm action of confirm dialog */
    if (action === 1) {
      this.onClearData();
      this._modalService.dismissAll();
    }
  }

  onCloseModalReference(name: string) {

    /*if (name == "mdlAddAdmin") {
      this.mdlAddAdmin.close();
    }*/
    if (name == "mdlAddTypePersonLightIdentity") {
      this.mdlAddTypePersonLightIdentity.close();
    }

    if (name == "mdlAddAsistenciaEvidencia") {
      this.mdlAddAsistenciaEvidencia.close();

    }

    if (name == "mdlAddServices") {
      this.mdlAddServices.close();
    }

    if (name == "mdlAddSection") {
      this._idServices = [];
      this.mdlAddSection.close();
    }

    if (name == "mdlAddProviders") {
      this.providersSelect = [];
      this.mdlAddProviders.close();
    }

  }

  onClearData() {
    this.companyEntity = {};
    this.userEntity = { roles: [], fingerprints: false, enabled: true };
    this.servicesToCompany = [];
  }

  /**
   * Validating if user select at least section of face or finger, (bio technology), is necessary at least for continued
   */
  protected validatingBioSections(content: any): void {

    /** If providers is empty, try again */
    if (this.listProviders.length === 0) {
      this.loadProvidersByServices();
    }

    /** Count of biometric technology selected */
    let bioSections: Set<number> = new Set<number>();
    this.selectFace = false; this.selectFingerPrints = false;

    this.sectionToEnroll.sort((a: any, b: any) => b.parent - a.parent).forEach(element => {
      if ((element.name === "FACE" || element.name === "FINGERPRINTS") && (element.checked || element['enabled'])) {
        /** Check if its unic section */
        bioSections.add(element.parent);
        /** Know bio active */
        if (element.name.toLocaleUpperCase() === "FACE") {
          this.selectFace = true;
        } else {
          this.selectFingerPrints = true;
        }
      }
    });

    /** Verify if count of sections is match with total sections */
    if (bioSections.size === this.numbersSections) {
      this.enabledOrNotServicesAndUnchecked();
      this.onSaveSections(content);
    } else {
      let _msg = this.catMsg.find(x => x.keyLg == "biometricRequired");
      this.eventService.errorMessage(0, _msg.textValue);
    }
  }

  onSaveSections(content: any) {
    try {

      console.log(this.currentUser);
      let _userData = JSON.parse(localStorage.getItem('currentUser'));

      //Validación de rol
      if (_userData.roles[0].id != EnumUserRol.SUPER_ADMIN) {
        this.onClearData();
        localStorage.setItem('status_session', '403');
        this._router.navigate(['list-documents']);
        this._modalService.dismissAll();
        return;
      }


      this.numberOfDocuments = "0";
      //Buscar la sección OTHER_DOCUMENTS 
      let otherDoc = this.sectionToEnroll.findIndex(x => x.name == "OTHER_DOCUMENTS");
      console.log(otherDoc);
      if (otherDoc != -1) {
        this.numberOfDocuments = this.fmSections.get("ddlDocuments")?.value;
        if (!this.numberOfDocuments) {
          let _msg = this.catMsg.find(x => x.keyLg == "documentsRequired");
          this.eventService.errorMessage(0, _msg.textValue);
          return;
        }
      }


      this.companyEntity.urlServiceINE = this.fmServices.get("txtUrlINE")?.value;

      this.mdlAddSection = this._modalService.open(content, { size: 'xl' });

    } catch (error) {
      console.log(error);
    }
  }

  onSaveServices(content: any) {
    try {



      this.companyEntity.urlServiceINE = this.fmServices.get("txtUrlINE")?.value;

      //Validar que exista al menos un servicio para la compañía 
      if (this.servicesToCompany.length == 0) {
        let _msg = this.catMsg.find(x => x.keyLg == "warningAddService");
        this.eventService.warningMessage(_msg.textValue);
        return;
      }

      //Validar si algún servicio de verificación del INE se está activando 
      let _serviceIne = this.servicesToCompany.findIndex(x => x.serviceId == EnumServicesValidation.VERIFICACION_INE_HUELLAS || x.serviceId == EnumServicesValidation.VERIFICACION_INE_ROSTRO);
      if (_serviceIne != -1 && this.companyEntity.urlServiceINE.length == 0) {
        let _msg = this.catMsg.find(x => x.keyLg == "errorIneURL");
        this.eventService.errorMessage(0, _msg.textValue);
        return;
      }

      //Validación URL
      if (this.showDivUrlINE && !this.validarURL(this.companyEntity.urlServiceINE)) {
        let _msg = this.catMsg.find(x => x.keyLg == "warningIneURL");
        this.eventService.warningMessage(_msg.textValue);
        return;
      }

      this._idServices = [];
      this.servicesToCompany.forEach(element => {
        if (element.checked) {
          this._idServices.push(element.serviceId);
        }
      });

      this.enableProviders();
      this.mdlAddProviders = this._modalService.open(content, { size: 'xl' });

    } catch (error) {
      console.log(error);
    }
  }

  private exceuteSaveToDatabase(request: CompanyCreateRq) {

    try {

      this.eventService.startLoadingData();

      this._service.CreateCompanyDetail(request).subscribe({
        next: (response: any) => {
          console.log(response);
          this.onClearData();
          this._modalService.dismissAll();
          this.eventService.successMessage(1);

          //recargar pantalla
          setTimeout(() => {
            window.location.reload();
          }, 3000);

        },
        error: (error: Response) => {

          console.log(error);
          let _error = error["error"];
          let _code = _error["code"];

          if (_code?.length > 0 && _code == "OPERATION_FAILED") {
            console.log(_error["message"]);
            this.eventService.errorMessage(3, _error["message"]);
          }
          else {
            this.eventService.errorMessage(2);
          }
        }
      });

      this.eventService.completeLoadingData();

    } catch (error) {
      console.log(error);
    }

  }

  validarURL(pUrl) {
    try {
      new URL(pUrl);
      return true;

    } catch (err) {
      return false;
    }
  }

  //Guardar info de la compañia
  onSaveCompanyAdminInfo(content: any) {

    try {
      let pass1 = this.fmCompanyUser.get("txtPassword")?.value;
      let pass2 = this.fmCompanyUser.get("txtPassword2")?.value;
      if (pass1 != pass2) {
        let _msg = this.catMsg.find(x => x.keyLg == "warningPasswordDoNotMatch");
        this.eventService.warningMessage(_msg.textValue);
        return;
      }

      if (this.fmCompanyUser.invalid) {
        let _msg = this.catMsg.find(x => x.keyLg == "errorFormValidation");
        this.eventService.warningMessage(_msg.textValue);
        return;
      }
      else {
        this.companyEntity.name = this.fmCompanyUser.get("txtName")?.value;
        this.companyEntity.rfc = this.fmCompanyUser.get("txtRFC")?.value;
        this.companyEntity.contact_name = this.fmCompanyUser.get("txtContactName")?.value;
        this.companyEntity.contact_email = this.fmCompanyUser.get("txtContactEmail")?.value;
        //this.mdlAddAdmin = this._modalService.open(content, { size: 'xl' });

        this.userEntity.name = this.fmCompanyUser.get("txtName")?.value;
        this.userEntity.username = this.fmCompanyUser.get("txtUserName")?.value;
        this.userEntity.phoneNumber = this.fmCompanyUser.get("txtPhone")?.value;
        this.userEntity.email = this.fmCompanyUser.get("txtEmail")?.value;
        this.userEntity.password = this.fmCompanyUser.get("txtPassword")?.value;
        this.userEntity.roles.push({ id: 1 });

        if (this.listEmailToNotifs.length <= 1) {
          this.listEmailToNotifs[0].mail = this.userEntity.email;
          this.listEmailToNotifs[0].isRegex = true;
          this.listEmailToNotifs.push({ mail: '', isRegex: false });
        }

      }
      console.log("Company =>", this.companyEntity);
      console.log("User admin=>", this.userEntity);
      this.mdlAddServices = this._modalService.open(content, { size: 'xl' });
    } catch (error) {
      console.log(error);
    }

  }

  onSaveUserAdmin(content: any) {

  }

  //Guardar info de type of person and light identity
  protected typePersonLightIdentity(content: any): void {

    /* IS OK FOR TYPE PERSONS --- IOMC
    let yes = (<HTMLInputElement> document.getElementById('physical')).checked;
    console.log(yes);
    let not = (<HTMLInputElement> document.getElementById('moral')).checked;
    console.log(not);*/

    console.log(this.fmTypePerson.get('mstLightIdentity').value);

    this.checkSectionByLightIdentity();
    console.log("Abriendo el modal para CAE");

    this.providersCAECat.forEach(element => {
      let item = this.providersCaeSelect.find(x => x.providerId == element.providerId && x.type == element.type);
      if (item != undefined) {
        element.checked = true;
      }
    });

    this.mdlAddTypePersonLightIdentity = this._modalService.open(content, { size: 'xl' });
  }

  protected assistanceEvidence(content: any): void {
    if (!this.activateAsistance) {
      this.mdlAddAsistenciaEvidencia = this._modalService.open(content, { size: 'xl' });
    } else {
      //Validar live y face
      if (!this.isValidCaeProvider) {
        this.eventService.errorMessage(3, "companies.assistance.errorCaeProvider");
        return;
      }

      let answerMailNotifs: boolean = this.questionsCat.find(q => q.questionId == "5").checked;
      if (answerMailNotifs) {

        //Limpiando repetidos
        this.uniqueEmailToNotifs = this.listEmailToNotifs.reduce((acc, current) => {
          const x = acc.find(item => item.mail === current.mail);
          if (!x) {
            acc.push(current);
          }
          return acc;
        }, []);

        //Check format regex and count for pass or message error
        let countMailRegexOk: number = 0;
        for (let mailU of this.uniqueEmailToNotifs) {
          countMailRegexOk = (mailU.mail?.search(this.regexEmail) >= 0) ? (countMailRegexOk + 1) : (countMailRegexOk - 1);
        }

        if (countMailRegexOk === this.uniqueEmailToNotifs.length) {
          this.mdlAddAsistenciaEvidencia = this._modalService.open(content, { size: 'xl' });
        } else {
          this.eventService.errorMessage(3, "companies.assistance.errorAddMailsToNotifs");
        }

      } else {
        this.mdlAddAsistenciaEvidencia = this._modalService.open(content, { size: 'xl' });
      }
    }


  }

  protected onChangeCheckQuestion(event: any, item: QuestionCompany): void {

    console.log(event, item);
    for (let question of this.questionsCat) {
      if (question.questionId === item.questionId) {
        question.checked = event.checked;
      }
    }

    if (item.questionId == "5") {
      this.isCehckbxIsNotifsMail = (item.questionId == "5" && event.checked);
    }

    if (item.questionId == "6") {
      this.isCehckbxIsBioStar = (item.questionId == "6" && event.checked);
      this.adjustValidatorsBio(item.questionId, event.checked);
    }

    if (item.questionId == "3") {
      this.isCbxFaceComparation = (item.questionId == "3" && event.checked);
      console.log(this.providersCaeSelect);
      if (!event.checked)
        this.providersCaeSelect = this.providersCaeSelect.filter(provider => provider.type !== 1);
      this.onValidateProvidersCAE();
    }

    if (item.questionId == "4") {
      this.isCbxLiveness = (item.questionId == "4" && event.checked);
      if (!event.checked)
        this.providersCaeSelect = this.providersCaeSelect.filter(provider => provider.type !== 2);
      this.onValidateProvidersCAE();
    }

  }

  protected addMailNotifs(): void {
    var validEmail = /^\w+([.-_+]?\w+)*@\w+([.-]?\w+)*(\.\w{2,10})+$/;
    if (validEmail.test(this.listEmailToNotifs[this.listEmailToNotifs.length - 1].mail)) {
      this.listEmailToNotifs.push({ mail: '', isRegex: true });
    }
  }

  protected deleteMailNotifs(idToDelete: number): void {
    this.listEmailToNotifs?.splice(idToDelete, 1);
  }

  protected setValueMailNotifs(idToEdit: number, event: any): void {
    if (this.listEmailToNotifs) { //Necessary this validation for trackBy on ngFor
      let mailValue: string = event?.target?.value;
      this.listEmailToNotifs[idToEdit].mail = mailValue;
      this.listEmailToNotifs[idToEdit].isRegex = (mailValue?.search(this.regexEmail) >= 0);
    }
  }

  /**
   * For can set validators the dynamic way, check if section is activated or not, if yes, then set validators, else remove it
   * and call method for update an validity form (is neccessary for each field)
   */
  private adjustValidatorsBio(id: string, checked: boolean): void {

    if (id == "6") {
      if (checked) {
        this.fmAssistanceG.txtBioUser.enable();
        this.fmAssistanceG.txtBioPassword.enable();
        this.fmAssistanceG.txtBioServert.enable();
        this.fmAssistanceG.txtBioPort.enable();
        this.fmAssistanceG.txtBioUser.addValidators(Validators.required);
        this.fmAssistanceG.txtBioPassword.addValidators(Validators.required);
        this.fmAssistanceG.txtBioServert.addValidators(Validators.required);
        this.fmAssistanceG.txtBioPort.addValidators([Validators.maxLength(5), Validators.pattern(this.regexOnlyNumbers), Validators.required]);
        this.updateValueAndValidityFormBio();
      } else {
        this.fmAssistanceG.txtBioUser.disable();
        this.fmAssistanceG.txtBioPassword.disable();
        this.fmAssistanceG.txtBioServert.disable();
        this.fmAssistanceG.txtBioPort.disable();
        this.fmAssistanceG.txtBioUser.removeValidators(Validators.required);
        this.fmAssistanceG.txtBioPassword.removeValidators(Validators.required);
        this.fmAssistanceG.txtBioServert.removeValidators(Validators.required);
        this.fmAssistanceG.txtBioPort.removeValidators([Validators.maxLength(5), Validators.pattern(this.regexOnlyNumbers), Validators.required]);
        this.updateValueAndValidityFormBio();
      }
    }

  }

  /**
   * Call method for update an validity form (is neccessary for each field)
   */
  private updateValueAndValidityFormBio(): void {
    this.fmAssistance.get('txtBioUser').updateValueAndValidity();
    this.fmAssistance.get('txtBioPassword').updateValueAndValidity();
    this.fmAssistance.get('txtBioServert').updateValueAndValidity();
    this.fmAssistance.get('txtBioPort').updateValueAndValidity();
  }

  changeInput() {
    this.show = !this.show;
  }

  changeInputConfirmPassword() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }

  protected changeBioStar() {
    this.showBioStar = !this.showBioStar;
  }

  onLoadCat() {

    this.eventService.startLoadingData();
    this._service.getQuestionsList().subscribe({
      next: (response: any) => {
        console.log(response?.body);
        this.questionsCat = response?.body;
        this.questionsCat = this.questionsCat.sort((a, b) => a.parent - b.parent);
        for (let question of this.questionsCat) {
          question.checked = true;
        }
      },
      complete: () => {
        this.eventService.completeLoadingData();
        this.questionsCat.find(question => question.questionId == "3").templateRef = this.templateFaceComparation;
        this.questionsCat.find(question => question.questionId == "4").templateRef = this.templateLiveness;
        this.questionsCat.find(question => question.questionId == "5").templateRef = this.templateCehckbxIsNotifsMail;
        this.questionsCat.find(question => question.questionId == "6").templateRef = this.templateCehckbxIsBioStar;
      },
      error: (msg) => {
        this.eventService.completeLoadingData();
        let _msg = this.catMsg.find(x => x.keyLg == "errorGetCatData");
        this.eventService.errorMessage(3, _msg.textValue);
        console.log(msg);
      }
    });

    this._service.getProvidersCaeList().subscribe({
      next: (response: any) => {
        this.providersCAECat = response?.body;
      },
      complete: () => {
        console.log(this.providersCAECat);        
      },
      error: (msg) => {
        this.eventService.completeLoadingData();
        let _msg = this.catMsg.find(x => x.keyLg == "errorGetCatData");
        this.eventService.errorMessage(3, _msg.textValue);
        console.log(msg);
      }
    });

    this._service.GetServicesList().subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log(response);
        console.log(_resultado);
        //Llenar el listado inicial 

        _resultado.forEach(element => {
          this.servicesCat.push(
            {
              checked: false,
              description: element.description,
              name: element.name,
              serviceId: element.serviceId,
              enabled: false
            }
          );
        });
      },
      error: (error: Response) => {
        let _msg = this.catMsg.find(x => x.keyLg == "errorGetCatData");
        this.eventService.errorMessage(3, _msg.textValue);
        console.log(error);
      }
    });

    this.catStatus = [
      {
        id: 1,
        name: "Activa",
        value: "1"
      },
      {
        id: 0,
        name: "Inactiva",
        value: "0"
      }
    ];

    this.catDocuments = [
      {
        id: 1,
        name: "1 - 5",
        keyLg: "1_5",
        value: "5"
      },
      {
        id: 0,
        name: "6 - 10",
        keyLg: "6_10",
        value: "10"
      },
      {
        id: 0,
        name: "11 - 15",
        keyLg: "11_15",
        value: "15"
      },
      {
        id: 0,
        name: "Más de 15",
        keyLg: "15_",
        value: "16"
      }
    ];

    this.catDocuments.forEach(element => {
      this.translate.stream('companies.' + element.keyLg).subscribe((res: string) => {
        element.name = res;
      });
    });



    this._service.GetSectionsList().subscribe({
      next: (response: any) => {
        let _resultado = response.body;
        console.log(response);
        console.log(_resultado);
        //Llenar el listado inicial 
        _resultado.forEach(element => {

          if (element.parent == EnumEnrollType.Movil_Android) {
            this.sectionCat_movil_android.push(
              {
                checked: true,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }
          else if (element.parent == EnumEnrollType.Web) {
            this.sectionCat_web.push(
              {
                checked: true,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }
          else if (element.parent == EnumEnrollType.Movil_iOS) {
            this.sectionCat_movil_iOS.push(
              {
                checked: true,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }
          else if (element.parent == EnumEnrollType.Web_responsive) {
            this.sectionCat_web_responsive.push(
              {
                checked: true,
                description: element.description,
                name: element.name,
                sectionId: element.sectionId,
                value: '',
                parent: element.parent,
                disabled: false
              }
            );
          }

          this.sectionToEnroll.push(
            {
              checked: true,
              description: element.description,
              name: element.name,
              sectionId: element.sectionId,
              value: '',
              parent: element.parent,
              disabled: false
            }
          );
        });
        this.loadProvidersByServices();
      },
      error: (error: Response) => {
        let _msg = this.catMsg.find(x => x.keyLg == "errorGetCatData");
        this.eventService.errorMessage(3, _msg.textValue);
        console.log(error);
      }
    });
  }

  private checkSectionByLightIdentity(): void {

    let array_sections: any[] = [{ section: this.sectionCat_movil_android }, { section: this.sectionCat_movil_iOS },
    { section: this.sectionCat_web_responsive }, { section: this.sectionCat_web },];

    this.sectionToEnroll = [];

    for (let i = 0; i < array_sections.length; i++) {
      for (let section of array_sections[i].section) {
        section.checked = this.isPermissionSectionByLigthIdentity(section.name);
        section.disabled = !this.isPermissionSectionByLigthIdentity(section.name);

        if (section.checked) {
          this.sectionToEnroll.push(section);
        }
      }
    }

  }

  private isPermissionSectionByLigthIdentity(name: string): boolean {
    name = name.toLocaleLowerCase();
    if (this.fmTypePerson.get('mstLightIdentity').value && (name === "fingerprints" || name.includes("huellas"))) {
      return false;
    }
    return true;
  }

  /** Check and set value enabled of services, and un checked when user back to sections */
  private enabledOrNotServicesAndUnchecked(): void {
    let isEnabled: boolean = true;
    let isChecked: boolean = true;

    this.servicesToCompany = [];

    this.servicesCat.forEach(element => {
      isEnabled = true;
      /** Validating
        * CA2. Validar si seleccionó el módulo de captura de rostro permitir seleccionar el servicio de "Comparación de ID vs Selfie" y/o el servicio de "Deduplicación biométrica" y si seleccionó el módulo de captura de huellas también permitir el servicio de "Deduplicación biométrica" 
        */
      let name = element.name.toLowerCase();
      if (name.includes("selfie") || name.includes("rostro")) {
        isEnabled = ((name.includes("selfie") || name.includes("rostro")) && this.selectFace);
        isChecked = ((name.includes("selfie") || name.includes("rostro")) && this.selectFace);
      } else if (name.includes("huellas")) {
        isEnabled = (this.fmTypePerson.get('mstLightIdentity').value) ? this.isPermissionSectionByLigthIdentity(name) : ((name.includes("huellas") && this.selectFingerPrints));
        isChecked = (this.fmTypePerson.get('mstLightIdentity').value) ? this.isPermissionSectionByLigthIdentity(name) : ((name.includes("huellas") && this.selectFingerPrints));
      }

      element.enabled = isEnabled;

      element.checked = isChecked;

      if (element.checked) {
        this.servicesToCompany?.push(element);
        let serviceINE = this.servicesToCompany.findIndex(x => x.serviceId == EnumServicesValidation.VERIFICACION_INE_HUELLAS || x.serviceId == EnumServicesValidation.VERIFICACION_INE_ROSTRO);

        this.showDivUrlINE = (serviceINE != -1);
      }

      isChecked = true;

    });
  }

  onChangeCheckService(event: any, item: ValidationServices) {
    let _checked = event.checked;
    let _exist = this.servicesToCompany?.findIndex(x => x.serviceId == item.serviceId);

    if (_exist == -1 && _checked) {
      item.checked = true;
      this.servicesToCompany?.push(item);
    }
    //Si existe y está marcado entonces eliminar
    if (_exist != undefined && _exist != -1 && !event.checked) {
      this.servicesToCompany?.splice(_exist, 1);
    }

    console.log(this.servicesToCompany);

    let serviceINE = this.servicesToCompany.findIndex(x => x.serviceId == EnumServicesValidation.VERIFICACION_INE_HUELLAS || x.serviceId == EnumServicesValidation.VERIFICACION_INE_ROSTRO);

    this.showDivUrlINE = (serviceINE != -1);
    console.log(serviceINE);

  }


  onKeyPress(event: any) {
    if (event.target.attributes) {
      let datavalidInput = event.target.attributes["data-valid"]["value"];
      if (datavalidInput != undefined && datavalidInput == "notnumber") {
        let keyCode = event.keyCode;

        if ((keyCode >= 48 && keyCode <= 57)) {
          return false;
        }
      }
    }
  }

  modelChanged(newObj: any) {
    let value = newObj.target.value;
    //console.log("value", value);
    if (newObj.target.attributes) {
      let dataTypeInput = newObj.target.attributes["data-type"]["value"];
      let datavalidInput = newObj.target.attributes["data-valid"]["value"];
      if (datavalidInput != undefined && datavalidInput == "notnumber") {
        let keyCode = newObj.keyCode;
        if ((keyCode >= 48 && keyCode <= 57)) {
          newObj.target.value = value.replace(newObj.key, "");
        }
      }
      this.dataNotSpace(dataTypeInput, newObj);
    }
  }

  dataNotSpace(dataTypeInput: string, newObj: any) {
    let value = newObj.target.value;

    if (dataTypeInput == "notspace") {
      newObj.target.value = value.trim();
    }
    else if (dataTypeInput == "notdoublespace") {
      let count = 0;
      let position = value.indexOf(" ");
      while (position !== -1) {
        count++;
        position = value.indexOf(" ", position + 1);
      }
      if ((count > 1 && value.length == 2) || (count > 2)) {
        newObj.target.value = value.trim();
      }
    }
  }

  onChangeCheckSection(event: any, item: CatEnrollSection) {
    let _checked = event.checked;
    let _exist = this.sectionToEnroll?.findIndex(x => x.sectionId === item.sectionId);

    if (_exist == -1 && _checked) {
      item.checked = true;
      this.sectionToEnroll?.push(item);
    }
    //Si existe y está marcado entonces eliminar
    if (_exist != undefined && _exist != -1 && !event.checked) {
      this.sectionToEnroll?.splice(_exist, 1);
    }
    console.log(this.sectionToEnroll);
  }

  private loadProvidersByServices(): void {
    this.eventService.startLoadingData();
    this._service.getProvidersForCompany().subscribe({
      next: (response: any) => {
        console.log(response);
        this.listProviders = response;
        this.listProviders.sort((a, b) => { return a.type - b.type; });
      },
      complete: () => { this.eventService.completeLoadingData(); },
      error: (msg) => {
        this.eventService.completeLoadingData();
        console.log(msg);
      }
    });
  }

  /** Enabled or disabled sections provider about CA of HU ( Configuración de proveedores para módulos Captura de rostro, Captura de huellas, Captura de identificación oficial ) */
  private enableProviders(): void {
    this.categoriasActivas = {};
    for (let provider of this.listProviders) {
      /**
       * CA: Cuando se haya elegido la opción de identidad Ligera, los proveedores de huella no deberán estar habilitados. 
       */
      if (provider.type === 1) {
        provider.disabledFront = ((this.fmTypePerson.get('mstLightIdentity').value) || !this.selectFingerPrints);
      }
      /**
       * CA: Los proveedores de captura de identificación oficial deberán estar siempre habilitados de tal forma que pueden seleccionar un proveedor de la lista. 
       */
      if (provider.type === 2) {
        provider.disabledFront = false;
      }
      /**
       * CA: La sección de comparación de rostro siempre estará habilitada sin excepción.
       */
      if (provider.type === 3) {
        provider.disabledFront = false;
      }
      /**
       * CA: Si no se selecciona la sección de captura de rostro, se deberán deshabilitar los proveedores de captura de rostro.
       */
      if (provider.type === 4) {
        provider.disabledFront = !this.selectFace;
      }

      if (!provider.disabledFront) {
        const categoriaId = provider.type;
        if (!this.categoriasActivas[categoriaId]) {
          this.categoriasActivas[categoriaId] = 1;
        } else {
          this.categoriasActivas[categoriaId]++;
        }
      }
    }

  }

  /** When user selected a provider, add the provider and delete other with same type */
  protected selectProvider(id: number, type: number): void {
    console.log("Click proveedor");
    for (let provider of this.listProviders) {
      if (provider.type === type) {
        if (provider.providerId === id) {
          /** Add provider */
          this.providersSelect.push(this.listProviders.find(p => p.providerId === id));
        } else {
          /** Delete provider */
          let providerToDelete = this.providersSelect.find(p => p.providerId !== id && p.type === type);
          if (providerToDelete) {
            let indice = this.providersSelect.indexOf(providerToDelete);
            this.providersSelect.splice(indice, 1);
          }
        }
      }
    }
  }

  protected selectProviderCAE(id: number, type: number): void {
    console.log("Click proveedor CAE", this.providersCaeSelect);
    for (let provider of this.providersCAECat) {
      if (provider.type === type) {
        if (provider.providerId === id) {
          /** Add provider */
          const exists = this.providersCaeSelect.some(p => p.providerId === id);
          if (!exists) {
            this.providersCaeSelect.push(provider);
          }
        } else {
          /** Delete provider */
          let providerToDelete = this.providersCaeSelect.find(p => p.providerId !== id && p.type === type);
          if (providerToDelete) {
            let indice = this.providersCaeSelect.indexOf(providerToDelete);
            this.providersCaeSelect.splice(indice, 1);
          }
        }
      }
    }
    this.onValidateProvidersCAE();

  }

  onValidateProvidersCAE(): void {
    let isValidLiveness = false;

    if (this.isCbxLiveness) {
      isValidLiveness = this.providersCaeSelect.filter(provider => provider.type === 2).length > 0;
    }
    else {
      isValidLiveness = this.providersCaeSelect.filter(provider => provider.type === 2).length == 0;
    }

    let isValidFace = false;
    if (this.isCbxFaceComparation) {
      isValidFace = this.providersCaeSelect.filter(provider => provider.type === 1).length > 0;
    }
    else {
      isValidFace = this.providersCaeSelect.filter(provider => provider.type === 1).length == 0;
    }

    this.isValidCaeProvider = isValidFace && isValidLiveness;

    let ids = this.providersCaeSelect.map(provider => provider.providerId);
    console.log(ids);
    console.log(this.isValidCaeProvider);
  }



  protected onSaveProvidersAndAll(): void {
    try {

      this.eventService.startLoadingData();

      let _userData = JSON.parse(localStorage.getItem('currentUser'));

      //Validación de rol
      if (_userData.roles[0].id != EnumUserRol.SUPER_ADMIN) {
        this.onClearData();
        localStorage.setItem('status_session', '403');
        this._router.navigate(['list-documents']);
        this._modalService.dismissAll();
        this.eventService.completeLoadingData();
        return;
      }

      /** Validación de proveedores */
      if (Object.keys(this.categoriasActivas).length !== this.providersSelect.length) {
        let _msg = this.catMsg.find(x => x.keyLg == "warningAddProvider");
        this.eventService.warningMessage(_msg.textValue);
        this.eventService.completeLoadingData();
        return;
      }

      let providersIdSelectFinal: number[] = [];
      this.providersSelect.forEach(element => {
        providersIdSelectFinal.push(element.providerId);
      });

      let _idSections = [];
      console.log(this.sectionToEnroll);
      this.sectionToEnroll.forEach(element => {
        if (element.checked) {
          _idSections.push(element.sectionId)
        }
      });

      /**
       * Adjust questions id selected
       */
      let questionsIdSelected: number[] = [];
      for (let question of this.questionsCat) {
        if (question.checked) {
          questionsIdSelected.push(parseInt(question.questionId));
        }
      }
      console.log(questionsIdSelected);

      /**
       * Adjust mails by question id 5
       */
      let mailsToNotifs: string = null;
      if (questionsIdSelected.includes(5) && this.activateAsistance) {
        mailsToNotifs = "";
        for (let mail of this.uniqueEmailToNotifs) {
          mailsToNotifs += mail.mail + ";";
        }
      }

      /**
       * Adjust BioStar by question id 6
       */
      let nameUser: string = null;
      let password: string = null;
      let ipServer: string = null;
      let port: string = null;
      if (questionsIdSelected.includes(6)) {
        nameUser = this.fmAssistanceG.txtBioUser.value;
        password = this.fmAssistanceG.txtBioPassword.value;
        ipServer = this.fmAssistanceG.txtBioServert.value;
        port = this.fmAssistanceG.txtBioPort.value;
      }

      //Llenar la compañía
      let request: CompanyCreateRq = {
        userAdmin: this.userEntity,
        name: this.companyEntity.name,
        rfc: this.companyEntity.rfc,
        numDocuments: Number.parseInt(this.numberOfDocuments),
        contactEmail: this.companyEntity.contact_email,
        contactName: this.companyEntity.contact_name,
        enabled: true,
        sectionsToActive: _idSections,
        servicesToActive: this._idServices,
        userId: this.currentUser.id,

        providersToActive: providersIdSelectFinal,
        identity: this.fmTypePerson.get('mstLightIdentity').value,

        caeEnabled: this.activateAsistance,
        questionsToActive: this.activateAsistance ? questionsIdSelected : [],
        configModCAE: this.activateAsistance ? {
          nameUser: nameUser,
          password: password,
          ipServer: ipServer,
          port: port,
          providersToActive: this.providersCaeSelect.map(provider => provider.providerId),
          emails: mailsToNotifs,
        } : {
          nameUser: '',
          password: '',
          ipServer: '',
          port: '',
          emails: '',
        }

      };
      console.log("Request create company=>");
      console.log(request);

      this.request = request;

      this.eventService.completeLoadingData();
      this.exceuteSaveToDatabase(this.request);

    } catch (error) {
      this.eventService.completeLoadingData();
      console.log(error);
    }
  }

  /**
   * For actions of by confirms dialogs, to do the correct process
   * @param $event For know the action to do
   */
  protected orchestratorCloseDialog($event: any): void {
    if (this.confirmationDialog.keyConfirmDialog === "confirmExitCreateCompany") {
      this.onClose($event);
    }
    this.isConfirmationDialog = false;
    this.confirmationDialog = new ConfirmationDialog();
  }

}